<template>
  <view class="login">
    <image class="login_logo" src="@/static/logo@2x.png" mode="widthFix" />
    <view class="login_title">元气森林</view>
    <view class="login_list">
      <view class="login_list_item">
        <image src="@/static/login_ic_phone@2x.png" mode="widthFix" />
        <input v-model="form.idCard" maxlength="18" type="number" placeholder="手机号">
      </view>
      <view class="login_list_item">
        <image src="@/static/login_ic_password@2x.png" mode="widthFix" />
        <input v-model="form.password" type="password" placeholder="密码">
      </view>
    </view>
    <view class="login_btn">
      <view class="login_btn_n">立即登录</view>
    </view>
  </view>
</template>

<script>
export default {
  name: 'login',

  data () {
    return {
      form: {
        idCard: '',
        password: ''
      }
    }
  },

  created () {
		
  },

  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
	.login {
		width: 100%;
		height: 100vh;
		display: flex;
		padding-top: 160rpx;
		box-sizing: border-box;
		align-items: center;
		flex-direction: column;
		background: linear-gradient(180deg, rgba(2,94,239,0.2) 0%, rgba(2,94,239,0) 100%);
		.login_logo {
			width: 180rpx;
			height: 180rpx;
		}
		.login_title {
			font-size: 44rpx;
			font-weight: 600;
			color: #333333;
			margin-top: 40rpx;
			margin-bottom: 120rpx;
		}
		.login_list {
			width: 100%;
			padding: 0 60rpx;
			box-sizing: border-box;
			.login_list_item {
				width: 100%;
				height: 98rpx;
				padding: 0 40rpx;
				box-sizing: border-box;
				background: #FFFFFF;
				border-radius: 8rpx;
				margin-bottom: 40rpx;
				display: flex;
				align-items: center;
				justify-content: space-between;
				&:last-child {
					margin-bottom: 0 !important;
				}
				image {
				  flex-shrink: 0;
				  width: 40rpx;
				  height: 40rpx;
				}
				input {
				  flex: 1;
				  height: 100%;
				  color: #666666;
				  margin-left: 24rpx;
				  border: none;
				}
			}
		}
		.login_btn {
			width: 100%;
			padding: 0 60rpx;
			box-sizing: border-box;
			margin-top: 80rpx;
			.login_btn_n {
				width: 100%;
				height: 98rpx;
				background: #025EEF;
				background: #025EEF;
				box-shadow: 0rpx 12rpx 24rpx 0rpx rgba(2,94,239,0.14);
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 32rpx;
				font-weight: 500;
				color: #FFFFFF;
				border-radius: 50rpx;
			}
		}
  }
</style>
